import {
  Lager_Core_Boardmember,
  Lager_Core_Signatory,
  Lager_Treyd_Users,
} from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

type CoreBoardMember = Pick<Lager_Core_Boardmember, 'member_id'>;
type CoreSignatory = Pick<Lager_Core_Signatory, 'member_id'>;

type Member = {
  core_boardmembers: CoreBoardMember[];
  core_signatories: CoreSignatory[];
};

export type CompanyUser = Pick<
  Lager_Treyd_Users,
  'user_id' | 'company_id' | 'can_sign_alone'
> & {
  member: Member;
};

export type CompanyOwners = {
  lager_treyd_users: CompanyUser[];
};

export type CompanyOwnersVariables = {
  companiesIds: number[];
  userId: number;
};

export const getCompanyOwnersQuery = gql`
  query getCompanyOwners($companiesIds: [bigint!], $userId: Int!) {
    lager_treyd_users(
      where: { company_id: { _in: $companiesIds }, user_id: { _eq: $userId } }
    ) {
      user_id
      company_id
      can_sign_alone
      member {
        core_boardmembers {
          member_id
        }
        core_signatories {
          member_id
        }
      }
    }
  }
` as TypedDocumentNode<CompanyOwners, CompanyOwnersVariables>;
